import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'

export const cardContainer = css`
  display: flex;
  align-items: center;
  padding: ${spacing(2)} ${spacing(2.5)};
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: ${spacing(2)};
  margin-bottom: ${spacing(1.5)};
  min-height: 80px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
`

export const timeContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 70px;
  margin-right: ${spacing(3)};
`

export const timeText = css`
  color: ${colors.white100};
  margin: 0;
  line-height: 1.2;
  font-weight: 200;
  font-size: 13px;
`

export const timeSubtext = css`
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  margin-left: 8px;
  line-height: 1;
  font-size: 10px;
  margin-top: 2px;
`

export const teamsContainer = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${spacing(1.5)};
  margin-right: ${spacing(2)};
`

export const teamSection = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const teamInfo = css`
  display: flex;
  align-items: center;
  gap: ${spacing(1.5)};
`

export const teamWrapper = css`
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: ${spacing(2)};
  padding: ${spacing(1.5)} ${spacing(2.5)};
  display: flex;
  align-items: center;
  margin-left: -8px;
  min-width: 80px;
  width: 80px;
`

export const teamLogo = css`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const logoImage = css`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
`

export const logoPlaceholder = css`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(255, 255, 255, 0.1);
`

export const teamAColor = css`
  background-color: #ff4444;
`

export const teamBColor = css`
  background-color: #4444ff;
`

export const logoText = css`
  color: ${colors.white100};
  margin: 0;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.5px;
`

export const teamText = css`
  color: ${colors.white100};
  margin: 0;
  font-size: 13px;
  font-weight: 400;
`

export const scoreContainer = css`
  min-width: 30px;
  text-align: center;
  margin-left: ${spacing(1)};
`

export const scoreText = css`
  color: ${colors.white100};
  margin: 0;
  font-weight: 700;
  font-size: 14px;
`

export const statusContainer = css`
  display: flex;
  align-items: center;
  min-width: 80px;
  justify-content: center;
`

export const verticalDivider = css`
  width: 1px;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.15);
  margin: 0 ${spacing(1.5)};
`

export const inwinButton = css`
  background-color: #6B73FF;
  border: none;
  border-radius: ${spacing(3)};
  padding: ${spacing(1.5)} ${spacing(3.125)};
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 88px;
  
  &:hover {
    background-color: #5a63e6;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(107, 115, 255, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`

export const inwinText = css`
  color: ${colors.white100};
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  font-style: italic;
  letter-spacing: 0.8px;
`

export const statusText = css`
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  font-size: 11px;
  font-weight: 500;
  text-align: center;
` 